<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="header-user-info">
          <div class="user-avatar">
            <img
              src="/img/user_icon.png"
              class="c-avatar-img"
              alt="User avatar"
            />
          </div>
          <span class="user-name d-md-down-none">{{ displayName }}</span>
          <span class="user-dropdown-arrow d-md-down-none">▾</span>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center text-light" color="dark" style="background: #1a3c2a;">
      <strong class="text-light">{{user.firstname}} {{user.lastname}}</strong><br>
      {{user.phone}}<br>
      {{roles[user.role]}}
    </CDropdownHeader>
    <!-- <CDropdownItem>
      <CIcon name="cil-bell"/> Notifications
      <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownItem @click="navigate('/settings')">
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem @click="navigate('/about')">
      <CIcon name="cil-info" /> About
    </CDropdownItem>
    <!-- <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownDivider/>
    <CDropdownItem @click="logout()"> 
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from 'axios';
import store from '../store';
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42,
      baseURL : store.state.baseURL,
      user : store.state.user,
      profileImageUrl : '/img/user_icon.png',
      name : '',
      phone : '',
      email : '',
      roles : {
        public : "Citizen",
        researcher : "Researcher",
        watchers : "Watchers or RRTs",
        rfo : "RFO & above",
        dfo : "DFO & above",
        ccf : "CCF & above",
        admin : "System Admin",
        Admin : "Wildlife Admin",
        subadmin : "Sub Admin",
        Editor : "Editor",
        Viewer : "Viewer"
      },
    }
  },
  computed: {
    displayName() {
      if (this.user && this.user.role) {
        return this.roles[this.user.role] || this.user.role;
      }
      return 'Wildlife Admin';
    }
  },
  created () {
    this.isLoggedIn();
    this.profileImageUrl = (this.baseURL + this.user.avatar);
    
  },
  methods : {
    navigate(link){
      this.$router.push({ path: link })
    },
    
    // updateUser(fcmkey){
    //   axios({
    //     url : this.baseURL + "user/update",
    //     method : "POST",
    //     headers : {
    //       authorization : store.state.token
    //     },
    //     data : {
    //       fcmkey : fcmkey
    //     }
    //   })
    //   .then(response => {
    //   })
    //   .catch(err => {
    //     console.log(err);
    //     this.$notify({
    //         group: 'notification',
    //         type : 'warn',
    //         title: 'Something went wrong!',
    //         text: "You might not receive notifications in web due to an unexpected error!"
    //     });
    //   })

    // },
    logout() {
        axios({
          url : this.baseURL + "user/logout",
          method : "GET",
          headers : {
            authorization : store.state.token
          }
        })
        localStorage.removeItem('token')
        store.commit('logoutUser')
        this.$router.push({ name: 'Login' })
      },
      isLoggedIn(){
        axios({
          url : this.baseURL + "isLoggedIn",
          method : "GET",
          headers : {
            authorization : store.state.token
          }
        })
        .then(response => {
          if(!response.data.status){
            axios({
              url : this.baseURL + "admin/logout",
              method : "GET",
              headers : {
                authorization : store.state.token
              }
            })
            store.commit('logoutUser')
            this.$router.push({ name: 'Login' })
          }
          else{
            store.commit('loginUser', {
                token : response.data.data.token,
                user  : response.data.data
            });
          }
        })
        .catch(err => {
          console.log("isLoggedIn error:", err);
          if (err.response && (err.response.status === 401 || err.response.status === 403)) {
            this.logout();
            this.$notify({
                group: 'notification',
                type : 'error',
                title: 'Error in authentication',
                text: "Session expired. Please login again!"
            });
          } else {
            console.error("Transient error during login check. Not logging out.", err);
          }
        })
        
      }
    },
    
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>